/* exported LFPluginRemoveSpaces */

const LFPluginRemoveSpaces = (() => {
  const _config = {
    bindToEvent: "blur",
  };

  const removeSpaces = (input) => {
    input.value = input.value.split(" ").join("").trim();
  };

  return {
    event: _config.bindToEvent,
    run: removeSpaces,
  };
})();

export default LFPluginRemoveSpaces;
